module.exports = __webpack_public_path__ + "static/img/logo-werkgeluk.01433a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-werkgeluk.svg
// module id = 4
// module chunks = 0